<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card" style="box-shadow:none">
          <form class="form-horizontal">
            <div class="card-body">
              <div ref="regularMap" class="map map-big" style="min-height: calc(100vh - 350px)"></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Loader} from 'google-maps'
  import Constants from 'src/utilities/constants'
  import {notifyWarning} from 'src/utilities/utils'

  export default {
    props: ['data'],
    data() {
      return {
        google: null,
        map: null,
        mapCenter: {lat: parseFloat(this.data.lat), lng: parseFloat(this.data.lng)},
      }
    },
    methods: {
      async initGoogleMap() {
        const apiKey = this.$store.get('config/byName', Constants.CONFIGS.GOOGLE_MAPS_API_KEY)
        const loader = new Loader(apiKey, {})
        const google = await loader.load()

        const mapOptions = {
          zoom: 10,
          center: new google.maps.LatLng(this.mapCenter),
          scrollwheel: false // we disable de scroll over the map, it is a really annoying when you scroll through page
        }
        const map = new google.maps.Map(this.$refs.regularMap, mapOptions)
        this.directionsDisplay = new google.maps.DirectionsRenderer()
        this.directionsDisplay.setMap(map)
        this.directionsDisplay.setPanel(this.$refs.directionsPanel)

        if (this.data.lat && this.data.lng) {
          const projectLat = parseFloat(this.data.lat)
          const projectLong = parseFloat(this.data.lng)

          //Set Project location marker
          new google.maps.Marker({
            position: {lat: projectLat, lng: projectLong},
            map: map,
          })
        } else {
          notifyWarning(this, "Address missing lat and/or lng.")
        }
      }
    },
    mounted() {
      this.initGoogleMap()
    }
  }
</script>

<style scoped>

</style>
